var modalTrigger = document.querySelectorAll(".search-modal-trigger");
var body = document.querySelector("body");
var searchInput = document.querySelector(".sf-input-text");
var resetButton = document.querySelector(".search-filter-reset");
var currentUrl = window.location.href.split('#')[0];
var links = document.querySelectorAll(".search-link");
  var modal = document.querySelector("#search-modal");

  
links.forEach((a) => {
  a.addEventListener("click", () => {
   var href =  a.getAttribute("href").split('#')[0];
   if (href == currentUrl) {
    body.classList.remove("modal-open", "overflow-hidden");
    modal.classList.add("hidden");
    modal.classList.remove("flex");

    searchInput.value = "";
    resetButton.click();
   }
  });
});


  modalTrigger.forEach((i) => {
    i.addEventListener("click", () => {
      body.classList.add("modal-open", "overflow-hidden");
      modal.classList.remove("hidden");
      modal.classList.add("flex");
      console.log(modal.lastElementChild.firstElementChild);
      modal.lastElementChild.firstElementChild.focus();
    
      setTimeout(function() {
        body.classList.add("modal-animate");
      }, 3);
    });
    modal.firstElementChild.addEventListener("click", () => {
      body.classList.remove("modal-open", "overflow-hidden");
      modal.classList.add("hidden");
      modal.classList.remove("flex");
      document.querySelector("#header-search").focus();
      searchInput.value = "";
      resetButton.click();
      setTimeout(function() {
        body.classList.remove("modal-animate");
    }, 200);
    });
    modal.lastElementChild.firstElementChild.addEventListener("click", () => {
      body.classList.remove("modal-open", "overflow-hidden");
      modal.classList.add("hidden");
      modal.classList.remove("flex");
      document.querySelector("#header-search").focus();
      searchInput.value = "";
      resetButton.click();
      setTimeout(function() {
        body.classList.remove("modal-animate");
    }, 200);
    });


});

